// Navigation entry for the Timeline screen, shown when the global flag AND the
// account's timeline toggle are both on (hooks/useTimelineEnabled).

// Not timeline_screen_enabled: builds already in the field read only that key,
// so it stays off and they keep hiding the Timeline.
export const TIMELINE_FLAG = 'timeline_by_account_enabled';
export const TIMELINE_SCREEN = 'ProjectTimeline';

/** Drops the Timeline item from a nav category list while the flag is off. */
export function withTimelineNav<T extends { key: string; items: Array<{ screen: string }> }>(
  categories: T[],
  timelineOn: boolean,
): T[] {
  if (timelineOn) return categories;
  return categories.map((cat) =>
    cat.items.some((it) => it.screen === TIMELINE_SCREEN)
      ? { ...cat, items: cat.items.filter((it) => it.screen !== TIMELINE_SCREEN) }
      : cat,
  );
}
